// Libraries
import { action, computed, observable } from "mobx";
import { AccountStore } from "Custom/Stores/Domain";
import { StoresInstance } from "Core/Base";
// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";

// Custom
import { Delcote25Model } from "Custom/Models/Domain/ProductSelector/SubModels/RoofSystemSubModels/DelcoteProductModels/Delcote25";

export class Delcote25ViewModel extends ViewModelBase<Delcote25Model> {
    private accountStore: AccountStore = StoresInstance.domain.AccountStore;
    constructor(model: Delcote25Model) {
        super(model);
        this.setDecorators(Delcote25Model);
    }

    // #region Product Properties

    @computed
    // eslint-disable-next-line prettier/prettier
    public get basecoatColours(): any[] {
        return this.model.basecoatColours;
    }

    @computed
    public get basecoatColourSelection(): any {
        return this.model.basecoatColourSelection;
    }

    @computed
    public get endlapMeterage(): number {
        return this.model.endlapMeterage;
    }

    @computed
    public get fixingCount(): number {
        return this.model.fixingCount;
    }

    @computed
    public get netRoofSquareMeterage(): number {
        return this.model.roofSquareMeterage - this.model.rooflightSquareMeterage;
    }

    @computed
    public get netRoofSquareMeterageValidationMessage(): string {
        /*         const result = this.validateDecorators("roofSquareMeterage");
        const retVal: string = this.accountStore.HasSubmitted === true ? (result.isValid === true ? "" : result.errorMessage) : "";
        return retVal; */
        // CMR The above works, when I call validate on the whole thing, but returns true always in this context, so hacking it
        let message = "";

        if (this.accountStore.HasSubmitted === true) {
            if (this.netRoofSquareMeterage < 0) {
                message = "Cannot be negative";
            }
        }
        return message;
    }

    @computed
    public get colourValidationMessage(): string {
        const result = this.validateDecorators("topcoatColourSelection");
        return !this.accountStore.HasSubmitted === true ? "" : result.isValid ? "" : result.errorMessage;
    }

    @computed
    public get overlapMeterage(): number {
        return this.model.overlapMeterage;
    }

    @computed
    public get profileCorrectionPercentage(): number {
        return this.model.profileCorrectionPercentage;
    }

    @computed
    public get ridgeFlashingsEtcMeterage(): number {
        return this.model.ridgeFlashingsEtcMeterage;
    }

    @computed
    public get rooflightSquareMeterage(): number {
        return this.model.rooflightSquareMeterage;
    }

    @computed
    public get roofSquareMeterage(): number {
        return this.model.roofSquareMeterage;
    }

    @computed
    public get topcoatColours(): any[] {
        return this.model.topcoatColours;
    }

    @computed
    public get topcoatColourSelection(): any {
        return this.model.topcoatColourSelection;
    }

    @action
    public setBasecoatColour = (selection: any): void => {
        this.model.basecoatColourSelection = selection;
    };

    @action
    public setEndlapMeterage = (value: number): void => {
        this.model.endlapMeterage = value;
    };

    @action
    public setFixingCount = (value: number) => {
        this.model.fixingCount = value;
    };

    @action
    public setOverlapMeterage = (value: number): void => {
        this.model.overlapMeterage = value;
    };

    @action
    public setProfileCorrectionPercentage = (value: number): void => {
        this.model.profileCorrectionPercentage = value;
    };

    @action
    public setRidgeFlashingsEtcMeterage = (value: number): void => {
        this.model.ridgeFlashingsEtcMeterage = value;
    };

    @action
    public setRooflightSquareMeterage = (value: number) => {
        this.model.rooflightSquareMeterage = value;
    };

    @action
    public setRoofSquareMeterage = (value: number) => {
        this.model.roofSquareMeterage = value;

        // Be aware of the rooflight area exceeding the roof area.
        if (this.model.rooflightSquareMeterage > this.model.roofSquareMeterage) {
            this.model.rooflightSquareMeterage = this.model.roofSquareMeterage;
        }
    };

    /*     @action
    public setTopcoatColour = (selection: any): void => {
        this.model.topcoatColourSelection = selection;

        let baseIndex: number = -1;
        // #5497 Delcote basecoat colour shoula always be "albany grey" unless the topcoat is "albany grey" in which case it should be "goosewing grey"
        if (selection.title.toLocaleLowerCase() === "albany grey") {
            baseIndex = this.model.basecoatColours.findIndex((a) => a.title.toLocaleLowerCase() === "albany grey");
        } else {
            baseIndex = this.model.basecoatColours.findIndex((a) => a.title.toLocaleLowerCase() === "goosewing grey");
        }

        if (baseIndex != -1) {
            this.model.basecoatColourSelection = this.model.basecoatColours[baseIndex];
        } else {
            this.model.basecoatColourSelection = this.model.basecoatColours[0];
        }
    }; */

    // #endregion Product Properties

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<Delcote25Model>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
